import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Box,
  CircularProgress,
  CssBaseline,
  Grid,
} from "@mui/material";
import DetailsPageHeader from "../../../../common/DetailsPageHeader";
import Sidebar from "../../../../common/Sidebar";
import { useLocation, useNavigate } from "react-router-dom";
import {
  drawerWidth,
  mainLayoutStyles,
  routes,
  showNotification,
  AddQuicktalesToAreaTableHeadCells,
} from "../../../../constants";

import { useQuickTalesContext } from "../../../../providers/OrganizationAdmin/QuickTalesProvider";
import { quickTalesSearch } from "../../../OrganizationAlbums/hooks/AlbumsHooks";

import { updateArea } from "../../hooks/AreaHook";
import CommonTable from "../../../../common/CommonTable";
import QuickTalesTableRow from "../../../../common/QuickTalesTableRow";
import TableSearchBar from "../../../../common/TableSearchBar";
import { useAuth } from "../../../../hooks";

const AddQTToAreaContainer = () => {
  const { currentUser } = useAuth();
  const { loading, setLoading, approvedQuickTales, handleGetAllQuickTales } =
    useQuickTalesContext();

  const location = useLocation();
  const navigate = useNavigate();

  const [areaDetails, setAreaDetails] = useState(location.state.areaDetails);
  const idsToRemove = areaDetails?.albumsAndQTs ?? []; // IDs to remove from the quicktales
  const [quictalesInOrg, setQuictalesInOrg] = useState([]);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    if (approvedQuickTales?.length) {
    } else {
      handleGetAllQuickTales();
    }
  }, [handleGetAllQuickTales]);

  useEffect(() => {
    setAreaDetails(location.state.areaDetails);
    let temp = [];
    if (location.state.areaDetails.albumsAndQTs) {
      areaDetails.albumsAndQTs.forEach((item) => {
        temp.push(item.id);
      });
    }

    const filteredQuicktales = approvedQuickTales.filter(
      (quicktale) => !temp.includes(quicktale.id)
    );
    console.log("idsToRemove", temp);
    setQuictalesInOrg(filteredQuicktales);
  }, [location.state, approvedQuickTales]);

  const handlePageLoadingClose = () => {
    setLoading(false);
  };

  const handleSearchQuickTales = async (e) => {
    try {
      let value = e.target.value;
      if (value.length >= 1) {
        let quicktalesSearchTemp = await quickTalesSearch(
          approvedQuickTales,
          value
        );
        setQuictalesInOrg(quicktalesSearchTemp);
      } else {
        setQuictalesInOrg(approvedQuickTales);
      }
    } catch (error) {
      console.log("error searching quicktales:", error.message);
    }
  };

  const handleSaveQuickTales = async (selectedQuickTales) => {
    console.log("selectedID", selectedQuickTales);
    try {
      // const existingQuicktales = areaDetails.quicktales || [];
      // const updatedQuicktales = [...selectedQuickTales, ...existingQuicktales];
      // const uniqueQuicktales = [...new Set(updatedQuicktales)];
      // console.log("Merged Quicktales:", uniqueQuicktales);
      // let dataTemp = {
      //   quicktales: uniqueQuicktales,
      //   updatedAt: new Date(),
      //   updatedBy: currentUser?.id,
      // };
      // console.log("dataTemp", dataTemp);

      const existingQuicktales = areaDetails.albumsAndQTs || [];
      const updatedQuicktales = [...existingQuicktales];
      let count = existingQuicktales.length + 1;
      selectedQuickTales.forEach((element) => {
        updatedQuicktales.push({
          id: element,
          type: "quicktales",
          position: count,
        });
        count++;
      });
      const uniqueQuicktales = [...new Set(updatedQuicktales)];
      console.log("Merged albums:", uniqueQuicktales);
      let dataTemp = {
        albumsAndQTs: uniqueQuicktales,
        updatedAt: new Date(),
        updatedBy: currentUser?.id,
      };
      console.log("dataTemp", dataTemp);

      let responseTemp = await updateArea(areaDetails.id, dataTemp);
      setAreaDetails((prevDetails) => ({
        ...prevDetails,
        albumsAndQTs: updatedQuicktales,
      }));

      let temp = [];
      if (location.state.areaDetails.albumsAndQTs) {
        areaDetails.albumsAndQTs.forEach((item) => {
          temp.push(item.id);
        });
      }

      const allIdsToRemove = [...temp, ...selectedQuickTales];
      // const allIdsToRemove = [...idsToRemove, ...selectedQuickTales];

      const filteredQuicktales = approvedQuickTales.filter(
        (quicktale) => !allIdsToRemove.includes(quicktale.id)
      );
      setQuictalesInOrg(filteredQuicktales);
      // await handleGetAllQuickTales();

      setSelected([]);
      showNotification("Area quicktales added successfully.");
      // Toast("success", "Area quicktales added successfully.");
    } catch (error) {
      console.log("error updating area quicktales:", error.message);
    }
  };

  return (
    <Box sx={{ display: "flex", width: "100%", paddingRight: 4 }}>
      <CssBaseline />
      <DetailsPageHeader
        mainTitle={`Add Quicktales to '${areaDetails && areaDetails.name}'`}
        bgColor="#fff"
        buttonText={"Edit"}
        selected={selected}
        setSelected={setSelected}
        editEnabled={true}
        cancelButton={true}
        loading={loading}
        submitButtonText={"Submit"}
        onCancelClick={() => {
          navigate(routes.areaDetails, {
            state: { areaDetails },
          });
        }}
        handleSave={() => handleSaveQuickTales(selected)}
      />
      <Sidebar />
      <Grid container style={{ ...mainLayoutStyles, background: "#fff" }}>
        <Grid container direction={"column"} style={subContainerStyles}>
          <TableSearchBar
            placeholder={"Search"}
            handleSearch={handleSearchQuickTales}
          />

          <CommonTable
            tableData={quictalesInOrg}
            selected={selected}
            setSelected={setSelected}
            CommonTableRow={QuickTalesTableRow}
            showPosition={false}
            tableHeadData={AddQuicktalesToAreaTableHeadCells}
            initialOrder="desc"
            initialOrderBy="approvalStatus.updatedAt"
          />
        </Grid>
      </Grid>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handlePageLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default AddQTToAreaContainer;

const subContainerStyles = {
  paddingLeft: 30,
  paddingRight: 30,
  marginTop: 50,
};
